// extracted by mini-css-extract-plugin
module.exports = {"container":"_26aW_","container2":"_157t0","languages":"dCpMW","language":"WeZB4","link":"_1MvAH","selected":"_2J6E_","closeButton":"_3F6iI"};